import { AboutStudio } from "../../DesktopComponents/AboutStudio/AboutStudio";
export const About = () => {
  return <AboutStudio />;
};
